import { ChevronLeft, ChevronRight } from "lucide-react";
import { ReactNode, useEffect, useState } from "react";
import { Button } from "../ui";

const Slider = ({
  slides,
  hideNextPrevButton = false,
  autoSlide = false,
}: {
  slides: ReactNode[];
  hideNextPrevButton?: boolean;
  autoSlide?: boolean;
}) => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  const nextSlide = () => {
    setCurrent((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);
  };

  // Auto slide effect
  useEffect(() => {
    if (autoSlide && !paused) {
      const interval = setInterval(nextSlide, 2000);
      return () => clearInterval(interval);
    }
  }, [autoSlide, paused, current]); // include paused + current dependencies

  return (
    <div
      className="relative w-full max-w-3xl mx-auto overflow-hidden rounded-lg"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div
        className="flex transition-transform duration-700 ease-in-out"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {slides.map((slide) => slide)}
      </div>

      {/* Controls */}
      {hideNextPrevButton ? (
        <></>
      ) : (
        <>
          <Button
            onClick={prevSlide}
            className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 text-white rounded hover:bg-black/70 cursor-pointer p-0"
          >
            <ChevronLeft />
          </Button>
          <Button
            onClick={nextSlide}
            className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 text-white rounded hover:bg-black/70 cursor-pointer p-0"
          >
            <ChevronRight />
          </Button>
        </>
      )}

      {/* Dots */}
      <div className="absolute bottom-4 w-full flex justify-center gap-2">
        {slides.map((_, idx) => (
          <div
            key={idx}
            onClick={() => setCurrent(idx)}
            className={`h-2 w-2 rounded-full cursor-pointer ${
              idx === current ? "bg-primary" : "bg-gray-300"
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default Slider;
